import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import VueSweetalert2 from 'vue-sweetalert2'
import App from './App.vue'
import router from './router'
import store from './store'
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css'
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'

Vue.use(VueAxios, axios)
Vue.use(VueSweetalert2)
// axios.defaults.withCredentials = true
Vue.config.debug = true
Vue.component('Loading', Loading)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const status = JSON.parse(localStorage.getItem('status'))
    if (status) {
      next()
    } else {
      next({
        path: '/login'
      })
    }
  } else {
    next()
  }
})
